import {EnrollmentFormModel} from 'models/EnrollmentForm';
import { GenericResponse } from 'types/Response';
import {
  CreateEnrollmentFormForCeoPayload,
  EnrollmentFormListResponse,
  EnrollmentFormResponse,
  ResendEnrollmentFormPayload,
  ResendEnrollmentFormResponse,
  SendInvitationPayload,
} from 'types/services/EnrollmentForm';
import axiosInstance from 'utils/axiosInstance';

const BASE_URL = `${process.env.REACT_APP_API_URL}/api/v1/enrollmentform`;
class EnrollmentFormService {
  async create(
    payload: EnrollmentFormModel
  ): Promise<EnrollmentFormResponse> {
    const { data } = await axiosInstance.post(
      `${BASE_URL}/createEnrollmentForm`,
      payload
    );

    return data;
  }

  async createForCeo(
    payload: CreateEnrollmentFormForCeoPayload
  ): Promise<EnrollmentFormResponse> {
    const { data } = await axiosInstance.post(
      `${BASE_URL}/createEnrollmentFormForCeo`,
      payload
    );

    return data;
  }

  async update(
    payload: EnrollmentFormModel,
    id: string
  ): Promise<EnrollmentFormResponse> {
    const { data } = await axiosInstance.put(
      `${BASE_URL}/updateEnrollmentForm/${id}`,
      payload
    );

    return data;
  }

  async delete(id: string): Promise<GenericResponse<void>> {
    const { data } = await axiosInstance.delete(
      `${BASE_URL}/deleteEnrollmentForm/${id}`
    );

    return data;
  }

  async archive(id: string): Promise<GenericResponse<void>> {
    const { data } = await axiosInstance.post(
      `${BASE_URL}/archiveEnrollmentForm/${id}`
    );

    return data;
  }

  async getList(): Promise<EnrollmentFormListResponse> {
    const { data } = await axiosInstance.get(
      `${BASE_URL}/getMyEnrollmentForms`
    );
    return data;
  }

  async getById(id: string): Promise<EnrollmentFormResponse> {
    const { data } = await axiosInstance.get(
      `${BASE_URL}/getEnrollmentFormById/${id}`
    );
    return data;
  }

  async sendInvitation(
    payload: SendInvitationPayload
  ): Promise<GenericResponse<boolean>> {
    const { data } = await axiosInstance.post(
      `${BASE_URL}/sendInvitation`,
      payload
    );

    return data;
  }

  async resendEnrollmentFormToEmail(
    payload: ResendEnrollmentFormPayload
  ): Promise<ResendEnrollmentFormResponse> {
    const { data } = await axiosInstance.post(
      `${BASE_URL}/resendEnrollmentForm`,
      payload
    );

    return data;
  }

  async resendEmailListSummary(id: string): Promise<GenericResponse<null>> {
    const { data } = await axiosInstance.post(
      `${BASE_URL}/resendEmailListSummary`,
      {
        enrollmentFormId: id,
      }
    );

    return data;
  }
}

export const EnrollmentFormServiceInstance = new EnrollmentFormService();
